import TimerActivityManager from '@/core/utils/TimerActivityManager'

export default {
    data() {
        return {
            smartTimers: new Map(),
            componentId: null
        }
    },

    created() {
        this.componentId = this.generateComponentId()
    },

    beforeDestroy() {
        this.destroyAllSmartTimers()
    },

    methods: {
        generateComponentId() {
            return `${this.$options.name || 'Component'}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        },

        createSmartTimer(timerName, callback, interval, options = {}) {
            const {
                immediate = false,
                autostart = true
            } = options

            if (this.smartTimers.has(timerName)) {
                this.destroySmartTimer(timerName)
            }

            let intervalId = null
            let isRunning = false

            const timerInstance = {
                start: () => {
                    if (!isRunning) {
                        if (immediate) {
                            this.safeExecuteCallback(callback, timerName)
                        }
                        intervalId = setInterval(() => {
                            this.safeExecuteCallback(callback, timerName)
                        }, interval)
                        isRunning = true
                    }
                },
                stop: () => {
                    if (isRunning && intervalId) {
                        clearInterval(intervalId)
                        intervalId = null
                        isRunning = false
                    }
                },
                isRunning: () => isRunning,
                destroy: () => {
                    timerInstance.stop()
                    TimerActivityManager.unregisterTimer(this.componentId, timerName)
                }
            }

            this.smartTimers.set(timerName, timerInstance)
            TimerActivityManager.registerTimer(this.componentId, timerName, timerInstance)

            if (autostart && TimerActivityManager.shouldTimersRun()) {
                timerInstance.start()
            }

            return timerInstance
        },

        safeExecuteCallback(callback, timerName) {
            try {
                if (typeof callback === 'function') {
                    callback()
                } else if (typeof callback === 'string' && this[callback]) {
                    this[callback]()
                } else {
                    throw new Error(`Callback inválido para timer ${timerName}`)
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`[SmartTimer] Erro ao executar callback do timer ${timerName}:`, error)
            }
        },

        startSmartTimer(timerName) {
            const timer = this.smartTimers.get(timerName)
            if (timer) {
                timer.start()
            }
        },

        stopSmartTimer(timerName) {
            const timer = this.smartTimers.get(timerName)
            if (timer) {
                timer.stop()
            }
        },

        destroySmartTimer(timerName) {
            const timer = this.smartTimers.get(timerName)
            if (timer) {
                timer.destroy()
                this.smartTimers.delete(timerName)
            }
        },

        destroyAllSmartTimers() {
            this.smartTimers.forEach((timer) => {
                timer.destroy()
            })
            this.smartTimers.clear()
        },

        isSmartTimerRunning(timerName) {
            const timer = this.smartTimers.get(timerName)
            return timer ? timer.isRunning() : false
        },

        getSmartTimerState() {
            const timers = {}
            this.smartTimers.forEach((timer, name) => {
                timers[name] = {
                    isRunning: timer.isRunning()
                }
            })
            
            return {
                componentId: this.componentId,
                timers,
                activityManagerState: TimerActivityManager.getState()
            }
        },

        replaceVueTimer(timerName, callback, interval, options = {}) {
            if (this.$timer && this.$timer[timerName]) {
                this.$timer.stop(timerName)
                delete this.$timer[timerName]
            }

            return this.createSmartTimer(timerName, callback, interval, options)
        }
    }
}